import api from './api';

// Incremental Server-Sent Events parser: push() raw text chunks as they
// arrive; onEvent(name, data) fires once per complete event.
export function createSSEParser(onEvent) {
  let buffer = '';
  return (chunk) => {
    buffer += chunk.replace(/\r\n?/g, '\n');
    let end;
    while ((end = buffer.indexOf('\n\n')) >= 0) {
      const block = buffer.slice(0, end);
      buffer = buffer.slice(end + 2);
      let event = 'message';
      const data = [];
      block.split('\n').forEach((line) => {
        if (line.startsWith('event:')) event = line.slice(6).trim();
        else if (line.startsWith('data:')) data.push(line.slice(5).replace(/^ /, ''));
      });
      if (data.length) onEvent(event, data.join('\n'));
    }
  };
}

// POST /chat/stream. Calls onDelta(text) for each reply fragment,
// onAction(action) for each action Gladys proposes (to confirm), and
// resolves with the saved { message, conversation } once the server sends
// "done".
export async function streamChat({ conversationId, message, onDelta, onAction, voice = false }) {
  if (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_DEMO === 'true') {
    return require('../demo/streams').streamChatDemo({ conversationId, message, onDelta, onAction, voice });
  }
  const token = localStorage.getItem('token');
  const res = await fetch(`${api.defaults.baseURL}/chat/stream`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'text/event-stream',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ conversation_id: conversationId || 0, message, ...(voice ? { voice: true } : {}) }),
  });

  if (res.status === 401) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login';
  }
  if (!res.ok || !res.body) {
    const body = await res.json().catch(() => null);
    throw new Error(body?.error || 'Échec de l’envoi du message.');
  }

  let result = null;
  let failure = null;
  const push = createSSEParser((event, data) => {
    const payload = JSON.parse(data);
    if (event === 'delta') onDelta?.(payload.text);
    else if (event === 'action') onAction?.(payload);
    else if (event === 'done') result = payload;
    else if (event === 'error') failure = payload.error;
  });

  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    push(decoder.decode(value, { stream: true }));
  }
  push(decoder.decode());

  if (failure) throw new Error(failure);
  if (!result) throw new Error('La connexion a été interrompue avant la fin de la réponse.');
  return result;
}
